import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import useFetch from '../../hooks/useFetch';

const JobPipelineHome = () => {
    const authState = useSelector((state) => state.authReducer || {});
    const [fetchData, { loading }] = useFetch();
    
    const isLoggedIn = authState?.isLoggedIn || false;
    const userName = authState?.user?.name || "Warrior";

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };

  const [activeTab, setActiveTab] = useState("dashboard");
  const [mode, setMode] = useState("sample"); 
  const [data, setData] = useState(null);

  const TabButton = ({ label, active, onClick }) => (
    <button
        onClick={onClick}
        className={`text-xs lg:text-sm px-2 py-2 font-medium ${
        active
            ? "bg-red-500 text-white"
            : "bg-blue-900 text-white hover:bg-blue-700"
        }`}
    >
        {label}
    </button>
    );

    const [liveScore, setLiveScore] = useState(70);

    useEffect(() => {
    if (mode !== "real") return;

    const interval = setInterval(async () => {
        const config = {
        url: "/jobpipeline/score",
        method: "get",
        headers: { Authorization: authState.token }
        };

        try {
        const data = await fetchData(config, { showSuccessToast: false });
        setLiveScore(data.score);
        } catch (err) {
        console.error("Score fetch failed:", err);
        clearInterval(interval); // STOP infinite loop
        }

    }, 3000);

    return () => clearInterval(interval);
    }, [mode, authState.token, fetchData]);

    const Card = ({ children }) => (
        <div className="bg-white p-4 rounded-xl shadow mb-4">{children}</div>
    );

    const loadSample = () => {
        setMode("sample");

        setData({
            dashboard: {
            score: 72,
            skills: { audit: 80, taxation: 60, finance: 70 },
            employerViews: 3
            }
        });
    };

    const loadReal = async () => {
  setMode("real");

  const config = {
    url: "/jobpipeline/dashboard",
    method: "get",
    headers: { Authorization: authState.token }
  };

  try {
    const data = await fetchData(config, { showSuccessToast: false });
    setData({ dashboard: data });
  } catch (err) {
    console.error("Dashboard fetch failed:", err);
    loadSample(); // fallback
  }
};

    const [pipeline, setPipeline] = useState([]);

const loadPipeline = async () => {
  if (mode === "sample") {
    setPipeline([
      { month: "Jan", activity: "Test", score: 78 }
    ]);
    return;
  }

  const config = {
    url: "/jobpipeline/pipeline",
    method: "get",
    headers: { Authorization: authState.token }
  };

  try {
    const data = await fetchData(config, { showSuccessToast: false });
    setPipeline(data);
  } catch (err) {
    console.error("Pipeline fetch failed:", err);
  }
};

const [jobs, setJobs] = useState([]);

const loadJobs = async () => {
  if (mode === "sample") {
    setJobs([{ title: "Audit Associate", match: 92 }]);
    return;
  }

  const config = {
    url: "/jobpipeline/jobs",
    method: "get",
    headers: { Authorization: authState.token }
  };

  try {
    const data = await fetchData(config, { showSuccessToast: false });
    setJobs(data);
  } catch (err) {
    console.error("Jobs fetch failed:", err);
  }
};



  return (
    <div className="min-h-screen bg-gray-100">
      <header className="sticky top-0 z-50 bg-black/90 backdrop-blur-xl border-b border-white/10 px-1 py-2 flex items-center justify-between">
        <div className="flex flex-col justify-left">
          <div className="flex text-lg lg:text-xl font-extrabold text-yellow-200">
            ➡️💼 Think5Whys JobPipeline
          </div>
          <div className="text-[10px] lg:text-sm">
            Future ready Talent Pipeline wirh Proof-of-Work.  
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-zinc-900 border-b border-white/10 px-5 py-6 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-col gap-4 items-center">
              <p className="text-lg font-medium">{userName}</p>
              <button onClick={handleLogout} className="w-full py-3 bg-red-600 rounded-2xl font-medium">
                ⏻
              </button>
            </div>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-full py-3 bg-white text-black rounded-2xl font-semibold"
            >
              🔐
            </button>
          )}
        </div>
      )}

      {/* TABS */}
      <div className="grid grid-cols-4 lg:grid-cols-6 gap-1">
        {["dashboard","pipeline","ai","jobs","employer","profile"].map(tab => (
          <TabButton
            key={tab}
            label={tab.toUpperCase()}
            active={activeTab === tab}
            onClick={() => setActiveTab(tab)}
          />
        ))}
      </div>

        <div className="flex gap-2 p-2">
        <button
            className="bg-green-500 text-white px-3 py-1 rounded"
            onClick={() => loadSample()}
        >
            Load Sample
        </button>

        <button
            className="bg-blue-500 text-white px-3 py-1 rounded"
            onClick={() => loadReal()}
        >
            Real Data
        </button>
        </div>

        <Card>
            <h2 className="text-xl font-bold">
                Career Score: {mode === "real" ? liveScore : data?.dashboard?.score}
            </h2>
            <p className="text-green-600">Real-time updating</p>
        </Card>

      <div className="p-4">
        {activeTab === "dashboard" && (
          <>
            <Card>
              <h2 className="text-xl font-semibold">
                Career Readiness: 72/100 ↑
              </h2>
            </Card>

            <Card>
              <h3 className="font-semibold mb-2">Skill Heatmap</h3>
              <p>Audit: 80%</p>
              <p>Taxation: 60%</p>
              <p>Finance: 70%</p>
            </Card>

            <Card>
              <h3 className="font-semibold">This Week</h3>
              <p>✔ 2 Tests Completed</p>
              <p>✔ 1 Project Uploaded</p>
            </Card>

            <Card>
              <h3 className="font-semibold">Employer Interest</h3>
              <p>3 companies viewed your profile</p>
            </Card>
          </>
        )}

        {activeTab === "pipeline" && (
          <>
            <Card>
              <h2 className="text-lg font-semibold">Career Timeline</h2>
              <p>Jan → Test (78%)</p>
              <p>Feb → GST Project</p>
              <p>Mar → Improvement +12%</p>
            </Card>

            <Card>
              <div className="flex gap-2">
                <button className="btn">Add Test</button>
                <button className="btn">Add Project</button>
                <button className="btn">Add Log</button>
              </div>
            </Card>

            <Card>
              <h3 className="font-semibold">AI Summary</h3>
              <p>You are improving in Taxation but weak in Finance.</p>
            </Card>
          </>
        )}

        {activeTab === "ai" && (
          <>
            <Card>
              <h2 className="font-semibold">AI Coach</h2>
              <input
                className="w-full border p-2 rounded mt-2"
                placeholder="Ask something..."
              />
            </Card>

            <Card>
              <h3>Suggestions</h3>
              <p>→ Take Audit Test</p>
              <p>→ Practice Case Study</p>
            </Card>

            <Card>
              <h3>Weekly Plan</h3>
              <p>Mon: Test</p>
              <p>Wed: Case Study</p>
            </Card>
          </>
        )}

        {activeTab === "jobs" && (
          <>
            <Card>
              <h2>Best Match (92%)</h2>
              <p>Audit Associate</p>
              <button className="btn mt-2">Apply</button>
            </Card>

            <Card>
              <h2>Growth Role (80%)</h2>
              <p>Tax Intern</p>
              <button className="btn mt-2">Apply</button>
            </Card>

            <Card>
              <h2>Stretch Role (65%)</h2>
              <p>Finance Analyst</p>
              <button className="btn mt-2">View Gap</button>
            </Card>
          </>
        )}

        {activeTab === "employer" && (
          <>
            <Card>
              <h2>Candidate</h2>
              <p>Name: Rahul Sharma</p>
              <p>Score: 82</p>
              <p>Trend: Improving</p>
            </Card>

            <Card>
              <h3>AI Insight</h3>
              <p>Strong in Audit, weak in Taxation</p>
            </Card>

            <Card>
              <div className="flex gap-2">
                <button className="btn">Track</button>
                <button className="btn">Shortlist</button>
              </div>
            </Card>
          </>
        )}

        {activeTab === "profile" && (
          <>
            <Card>
              <h2>Sanjeev Kumar</h2>
              <p>Score: 78</p>
              <p>Trend: Improving</p>
            </Card>

            <Card>
              <h3>Skills</h3>
              <p>Audit: 80%</p>
              <p>Taxation: 60%</p>
            </Card>

            <Card>
              <h3>Projects</h3>
              <p>✔ GST Case Study</p>
              <p>✔ Financial Analysis</p>
            </Card>
          </>
        )}

      </div>

        <footer className="bg-black border-t border-white/10 py-8 px-4 text-center text-xs text-zinc-400">
            <div className="max-w-md mx-auto">
              © 2026 JobPipeline • Future ready Talent Pipeline wirh Proof-of-Work.<br />
              <div className="flex justify-center gap-6 mt-6 text-sm">
                <Link to="/about-us" className="hover:text-emerald-400 transition">About</Link>
                <Link to="/privacy-policy" className="hover:text-emerald-400 transition">Privacy</Link>
                <Link to="/terms-of-use" className="hover:text-emerald-400 transition">Terms</Link>
                <Link to="/contact-us" className="hover:text-emerald-400 transition">Contact</Link>
              </div>
            </div>
        </footer>
    </div>

  );
};

export default JobPipelineHome;